<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { device_ui } from 'src/stores/features/device-ui';
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';

	// Design System Components

	// Components
	import { getDeviceChartsConfig } from 'src/components/Chart/chart_config';
	import { useNavigateToHistoryStatisticsTab } from 'src/components/Sidepanel/useNavigateToHistoryStatisticsTab';
	import { viewComponentRegistry } from 'src/components/Sidepanel/view-registry';
	import { getCurrentView } from 'src/components/Sidepanel/view-helpers';

	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const { navigateToHistoryStatisticsTab } = useNavigateToHistoryStatisticsTab();

	const deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statusesRaw =
		status?.online && (typeof deviceConfig !== 'undefined' || device?.type === 'peripheral-device')
			? status_configurator(status, device, settings)
			: [];

	// Declare _statuses before using in reactive declarations to avoid lint error
	let _statuses: any[] = [];
	$: _statuses = Array.isArray(_statusesRaw) ? _statusesRaw : [];

	$: deviceChartsConfig = device ? getDeviceChartsConfig(device) : [];

	const handleOnClickThumbChart = () => {
		navigateToHistoryStatisticsTab();
	};

	$: view = getCurrentView(device, $device_ui);
	$: componentRegistryKey =
		device?.type === 'peripheral-device' ? 'peripheral_device' : view?.category;
	$: component =
		viewComponentRegistry?.[componentRegistryKey]?.[view?.variant] ??
		viewComponentRegistry?.[componentRegistryKey]?.['basic'];

	// Make labelList reactive to status, device, and settings changes
	$: if (status?.online && typeof deviceConfig !== 'undefined') {
		const result = status_configurator(status, device, settings);
		_statuses = Array.isArray(result) ? result : [];
	}
</script>

{#if component}
	<svelte:component
		this={component}
		{device}
		statuses={_statuses}
		{deviceChartsConfig}
		{handleOnClickThumbChart}
	/>
{/if}
